export default __webpack_public_path__ + "static/media/2-2-3.27dbfb5e.jpg";